/**
 * Keep the cloud timeline's origin and duration aligned with the sequencer's
 * merged-node timeline, including audio-only intro and outro padding.
 *
 * @param {Array<{getStartTimeOffset: Function, getEndTimeOffset: Function}> & {totalPlaybackDurationInMilliseconds?: number}} mergedNodeSchedulingInfoArray
 * @returns {{firstNodeStartTimeMs: number, totalDurationMs: number}}
 */
function getTimeloomTimelineMetrics(mergedNodeSchedulingInfoArray) {
    const firstNodeStartTimeMs = mergedNodeSchedulingInfoArray.length > 0
        ? mergedNodeSchedulingInfoArray[0].getStartTimeOffset()
        : 0;
    const totalDurationMs = mergedNodeSchedulingInfoArray.totalPlaybackDurationInMilliseconds
        || (mergedNodeSchedulingInfoArray.length > 0
            ? Math.max(...mergedNodeSchedulingInfoArray.map(node => node.getEndTimeOffset())) - firstNodeStartTimeMs
            : 0);

    return { firstNodeStartTimeMs, totalDurationMs };
}

module.exports = { getTimeloomTimelineMetrics };
